module.exports = __webpack_public_path__ + "img/Purchase.f4a4a9ec.svg";